export default __webpack_public_path__ + "static/sc-digital-029cde66ddafdd2daee4a98aaef7972a.webp";